"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainId = exports.ChainNames = void 0;
var ChainNames;
(function (ChainNames) {
    ChainNames["Mainnet"] = "mainnet";
    ChainNames["Ropsten"] = "ropsten";
    ChainNames["Rinkeby"] = "rinkeby";
    ChainNames["Goerli"] = "goerli";
    ChainNames["Kovan"] = "kovan";
    ChainNames["Xdai"] = "xdai";
    ChainNames["Bsc"] = "bsc";
    ChainNames["BscTest"] = "bscTest";
    ChainNames["Fantom"] = "fantom";
    ChainNames["FantomTest"] = "fantomTest";
    ChainNames["Matic"] = "matic";
    ChainNames["Mumbai"] = "mumbai";
    ChainNames["Aurora"] = "aurora";
    ChainNames["AuroraTest"] = "auroraTest";
    ChainNames["Avalanche"] = "avalanche";
    ChainNames["Fuji"] = "fuji";
    ChainNames["Optimism"] = "optimism";
    ChainNames["OptimismKovan"] = "optimismKovan";
    ChainNames["Arbitrum"] = "arbitrum";
    ChainNames["ArbitrumTest"] = "arbitrumTest";
    ChainNames["Moonbeam"] = "moonbeam";
    ChainNames["Moonbase"] = "moonbase";
    ChainNames["Celo"] = "celo";
    ChainNames["CeloTest"] = "celoTest";
})(ChainNames = exports.ChainNames || (exports.ChainNames = {}));
// NOTE: Update chainId for networks we're planning to support
var ChainId;
(function (ChainId) {
    // Ethereum
    ChainId[ChainId["MAINNET"] = 1] = "MAINNET";
    ChainId[ChainId["GOERLI"] = 5] = "GOERLI";
    ChainId[ChainId["POLYGON_MUMBAI"] = 80001] = "POLYGON_MUMBAI";
    ChainId[ChainId["POLYGON_MAINNET"] = 137] = "POLYGON_MAINNET";
    ChainId[ChainId["BSC_TESTNET"] = 97] = "BSC_TESTNET";
    ChainId[ChainId["BSC_MAINNET"] = 56] = "BSC_MAINNET";
    ChainId[ChainId["POLYGON_ZKEVM_TESTNET"] = 1442] = "POLYGON_ZKEVM_TESTNET";
    ChainId[ChainId["POLYGON_ZKEVM_MAINNET"] = 1101] = "POLYGON_ZKEVM_MAINNET";
    ChainId[ChainId["ARBITRUM_GOERLI_TESTNET"] = 421613] = "ARBITRUM_GOERLI_TESTNET";
    ChainId[ChainId["ARBITRUM_ONE_MAINNET"] = 42161] = "ARBITRUM_ONE_MAINNET";
    ChainId[ChainId["ARBITRUM_NOVA_MAINNET"] = 42170] = "ARBITRUM_NOVA_MAINNET";
    ChainId[ChainId["OPTIMISM_MAINNET"] = 10] = "OPTIMISM_MAINNET";
    ChainId[ChainId["OPTIMISM_GOERLI_TESTNET"] = 420] = "OPTIMISM_GOERLI_TESTNET";
    ChainId[ChainId["AVALANCHE_MAINNET"] = 43114] = "AVALANCHE_MAINNET";
    ChainId[ChainId["AVALANCHE_TESTNET"] = 43113] = "AVALANCHE_TESTNET";
    ChainId[ChainId["MOONBEAM_MAINNET"] = 1284] = "MOONBEAM_MAINNET";
    ChainId[ChainId["BASE_GOERLI_TESTNET"] = 84531] = "BASE_GOERLI_TESTNET";
    ChainId[ChainId["BASE_MAINNET"] = 8453] = "BASE_MAINNET";
    ChainId[ChainId["LINEA_TESTNET"] = 59140] = "LINEA_TESTNET";
    ChainId[ChainId["MANTLE_MAINNET"] = 5000] = "MANTLE_MAINNET";
    ChainId[ChainId["MANTLE_TESTNET"] = 5001] = "MANTLE_TESTNET";
    ChainId[ChainId["OPBNB_MAINNET"] = 204] = "OPBNB_MAINNET";
    ChainId[ChainId["OPBNB_TESTNET"] = 5611] = "OPBNB_TESTNET";
    ChainId[ChainId["GANACHE"] = 1337] = "GANACHE";
})(ChainId = exports.ChainId || (exports.ChainId = {}));
//# sourceMappingURL=ChainsTypes.js.map